import Axios from 'axios';
import sha256 from 'js-sha256';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { goRiceUrl } from '../../../../constant/siteConstants';
import getConfigToken from '../../../../utils/getConfigToken';
import useFormatMessage from '../../../../utils/useFormatMessage';
import PermissionTab from '../common/PermissionTab';
import Taseron from '../TaseronGrupYonetimi/Taseron';
import InformationForm from './InformationForm';
import MarkaRoleYonetimi from '../MarkaRolYonetimi/MarkaRoleYonetimi';

export default function EmployeeAddModal({ employeeAddModal, setEmployeeAddModal, trigger, setTrigger }) {
    const notifySuccess = (message) => toast.success(message);
    const notifyError = (message) => toast.error(message);
    const [selectedPermissionGroup, setSelectedPermissionGroup] = useState([]);
    const { t } = useFormatMessage();
    //eslint-disable-next-line
    const [employeeUpdateNumber, setEmployeeUpdateNumber] = useState(0);
    const [currentActiveTab, setCurrentActiveTab] = useState('1');
    const [permissionGroupDatas, setPermissionGroupDatas] = useState([]);


    const [roleGroups, setRoleGroups] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [phoneNumber, setPhoneNumber] = useState("");
    const [selectedRow, setSelectedRow] = useState(initialEmployeeData());

    function initialEmployeeData() {
        return {
            employee_id: 0, email: "", full_name: "", user_name: "",
            cinsiyet: "", password: "", is_active: false, redirect_path: "", user_phone: null, warehouse_id: null, brand_ids: [], subcontractor_ids: []
        };
    }

    // Fetch role groups
    async function getRoleGroups() {
        try {
            const resp = await Axios.post(`${goRiceUrl}/api/employee/getAllRolesAndRoleGroup`, {}, getConfigToken);

            const updatedRoles = [];
            resp.data.forEach((obj) => {
                updatedRoles.push({ ...obj, checked: false });
            });
            setRoleGroups({ Datas: updatedRoles });

        } catch (error) {
            console.error(error);
            notifyError("Rol Grupları yüklenirken servis hatası.");
        }
    }

    // Fetch permission groups
    async function getPermissionGroups() {
        try {
            const resp = await Axios.post(`${goRiceUrl}/api/employee/getPermissionGroupsWithRoles`, {}, getConfigToken);
            setPermissionGroupDatas(resp.data);
        } catch (error) {
            console.error(error);
            notifyError("Yetki Grupları yüklenirken servis hatası.");
        }
    }

    // Validate employee data
    function validateObject() {
        if (!(parseInt(document.getElementById("firma")?.childNodes[0]?.childNodes[0]?.value) > 0)) {
            notifyError("Kullanıcının firması seçilmeli.");
            return false;
        }
        const fields = ["fullName", "userName", "email", "password", "password2"];
        for (const field of fields) {
            if (document.getElementById(field).value === "") {
                notifyError(`${field} boş olamaz.`);
                return false;
            }
        }

        const password = document.getElementById("password").value;
        if (password !== document.getElementById("password2").value) {
            notifyError("Şifreler eşleşmiyor.");
            return false;
        }


        return true;
    }
    function createUserRole(id) {
        Axios.post(`${goRiceUrl}/api/employee/setRoles`, {
            user_id: parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii')),
            employee_id: id,
            permission_group_ids: selectedPermissionGroup,
            special_role_ids: selectedRowKeys
        }, getConfigToken).then((resp) => {
            notifySuccess("Yeni kullanıcı kaydı başarıyla oluşturuldu.")
            setEmployeeAddModal(false);
            setTrigger(!trigger)
        })
    }


    // Add new employee
    async function addNewEmployee() {
        let phoneInput = document.querySelector("#phone-number > div > input").value

        const brandCols = document.getElementsByClassName("brandCol");
        const selectedBrands = [];
        for (let i = 0; i < brandCols.length; i++) {
            const brandCol = brandCols[i];
            const checkBox = brandCol.childNodes[0].childNodes[0];
            if (checkBox.value === 'true') {
                selectedBrands.push(parseInt(brandCol.id.split("-")[1]));
            }
        }

        const taseronCols = document.getElementsByClassName("taseronCol");
        const selectedTaseron = [];
        for (let i = 0; i < taseronCols.length; i++) {
            const taseronCol = taseronCols[i];
            const checkBox = taseronCol.childNodes[0].childNodes[0];
            if (checkBox.value === 'true') {
                selectedTaseron.push(parseInt(taseronCol.id.split("-")[1]));
            }
        }


        if (validateObject()) {
            try {
                const response = await Axios.post(`${goRiceUrl}/api/employee/add`, {
                    "cinsiyet": document.getElementById("cinsiyet").childNodes[0].childNodes[0].value,
                    "email": document.getElementById("email").value,
                    "full_name": document.getElementById("fullName").value,
                    "password": sha256(document.getElementById("password").value),
                    "redirect_path": (document.getElementById("url").value).trim(),
                    "user_id": parseInt(Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii')),
                    "user_name": document.getElementById("email").value,
                    "user_phone": ((phoneInput === "" || phoneInput === "+90") ? null : phoneInput)?.replaceAll(" ", ""),
                    "warehouse_id": document.getElementById("depo").childNodes[0].childNodes[0].value !== "" ? parseInt(document.getElementById("depo").childNodes[0].childNodes[0].value) : null,
                    "brand_ids": selectedBrands,
                    "subcontractor_ids": selectedTaseron,
                    "party_id": parseInt(document.getElementById("firma").childNodes[0].childNodes[0].value) || 0,
                }, getConfigToken);

                if (response.status === 200) {
                    // TODO Enes Bekliyor
                    createUserRole(response.data.employee_id);
                    setEmployeeAddModal(false);
                    notifySuccess("Yeni kayıt başarıyla oluşturuldu.");
                } else {
                    notifyError("Kayıt oluşturulurken hata.");
                }
            } catch (error) {
                console.error(error);
                notifyError("Servis hatası.");
            }
        }
    }

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(() => {
        if (employeeAddModal) {
            getRoleGroups();
            getPermissionGroups();
            setSelectedRow(initialEmployeeData());
        }
    }, [employeeAddModal]);
    /* eslint-disable react-hooks/exhaustive-deps */
    const toggle = tab => {
        if (currentActiveTab !== tab) setCurrentActiveTab(tab);
    }

    return (
        <Modal size="lg" isOpen={employeeAddModal} toggle={() => setEmployeeAddModal(false)}>
            <ModalHeader toggle={() => setEmployeeAddModal(false)}>{t("Yeni Kayıt Formu")}</ModalHeader>
            <ModalBody>
                <Col>
                    <Nav tabs className='mb-2'>
                        <NavItem><NavLink active={currentActiveTab === '1'} onClick={() => setCurrentActiveTab('1')}>{t("Kullanıcı Bilgileri")}</NavLink></NavItem>
                        <NavItem><NavLink active={currentActiveTab === '2'} onClick={() => setCurrentActiveTab('2')}>{t("Yetkilendirme")}</NavLink></NavItem>
                        <NavItem><NavLink active={currentActiveTab === '3'} onClick={() => setCurrentActiveTab('3')}>{t("Diğer Yetkiler")}</NavLink></NavItem>
                    </Nav>
                    <TabContent activeTab={currentActiveTab}>

                        <TabPane tabId="1">
                            <InformationForm
                                toggle={toggle}
                                employeeUpdateNumber={employeeUpdateNumber}
                                phoneNumber={phoneNumber}
                                setPhoneNumber={setPhoneNumber}
                                employeeDetail={selectedRow}
                                setSelectedRow={setSelectedRow}
                            />
                        </TabPane>
                        <TabPane tabId="2">
                            <PermissionTab
                                selectedRowKeys={selectedRowKeys}
                                setSelectedRowKeys={setSelectedRowKeys}
                                roleGroups={roleGroups}
                                permissionGroupDatas={permissionGroupDatas}
                                selectedPermissionGroup={selectedPermissionGroup}
                                setSelectedPermissionGroup={setSelectedPermissionGroup}
                                toggle={toggle}

                            />
                        </TabPane>
                        <TabPane tabId="3">
                            <Taseron />

                            <hr />

                            <MarkaRoleYonetimi />

                        </TabPane>
                    </TabContent>
                </Col>
            </ModalBody>
            <ModalFooter>
                <Button color='danger' onClick={() => setEmployeeAddModal(false)}>{t("İptal")}</Button>
                <Button color='primary' onClick={addNewEmployee}>{t("Kaydet")}</Button>
            </ModalFooter>
        </Modal>
    );
}
